import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const HeroSection = styled.section`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  color: #fff;
  position: relative;
  overflow: hidden;
`;

const Content = styled.div`
  text-align: left;
  max-width: 800px;
  padding: 0 2rem;
  z-index: 2;

  h1 {
    font-size: 3.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
    font-family: var(--secondary-font-family);
  }

  p {
    font-size: 1.2rem;
    margin-bottom: 2rem;
    opacity: 0.8;
    font-family: var(--secondary-font-family);
    text-align: left;
  }
`;

const MatrixBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.1;
  z-index: 1;
`;

const ActionButton = styled.a`
  display: inline-block;
  padding: 1rem 2rem;
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
  text-decoration: none;
  font-family: var(--secondary-font-family);
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background: #fff;
    color: #000;
  }
`;

const Hero: FC = () => {
  const { t } = useTranslation();

  const [text, setText] = useState('');
  const fullText = t('hero.title');
  
  useEffect(() => {
    let currentText = '';
    let index = 0;
    
    const timer = setInterval(() => {
      if (index < fullText.length) {
        currentText += fullText[index];
        setText(currentText);
        index++;
      } else {
        clearInterval(timer);
      }
    }, 100);

    return () => clearInterval(timer);
  }, [fullText]);

  return (
    <HeroSection>
      <MatrixBackground />
      <Content>
        <h1>{text}_</h1>
        <p>
          {t('hero.subtitle')}
          <br />
          JavaScript | React | Next.js | TypeScript
        </p>
        <ActionButton href="#projects">
          {t('hero.action_button')}
        </ActionButton>
      </Content>
    </HeroSection>
  );
};

export default Hero;